// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const emboar: PokeData = {
  "id": 500,
  "name": "emboar",
  "height": 16,
  "weight": 1500,
  "base_experience": 238,
  "types": [
    PokeType.FIRE,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "tail-whip",
    "roar",
    "ember",
    "flamethrower",
    "defense-curl",
    "smog",
    "rollout",
    "arm-thrust",
    "odor-sleuth",
    "hammer-arm",
    "assurance",
    "flare-blitz",
    "head-smash",
    "flame-charge",
    "heat-crash"
  ],
  "moves": [
    "tackle",
    "ember",
    "flamethrower",
    "flare-blitz",
    "double-kick",
    "blaze-kick",
    "morning-sun",
    "fire-fang",
    "coaching",
    "rolling-kick",
    "sunny-day",
    "fire-ball",
    "karate-chop"
  ],
  "evolution_chain": {
    "id": 257,
    "item": null,
    "species": [
      {
        "name": "tepig",
        "order": 499,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "pignite",
        "order": 500,
        "types": [
          PokeType.FIRE,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 498,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 17,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "emboar",
        "order": 501,
        "types": [
          PokeType.FIRE,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 499,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 127,
    "speed": 94,
    "ability_power": 179
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
